import { focusableSelector } from './focusable-selector';

export const trapFocus = (element: HTMLElement | null | undefined) => {
	if (!element) return;
	const focusable = element.querySelectorAll<HTMLElement>(focusableSelector);
	if (!focusable.length) return;

	const firstFocusable = focusable[0];
	const lastFocusable = focusable[focusable.length - 1];

	if (!firstFocusable || !lastFocusable) return;

	let trapped = false;

	const handleKeyDown = (event: KeyboardEvent) => {
		if (event.key !== 'Tab' || !trapped) return;
		if (!element?.contains(document.activeElement)) {
			trapped = false;
			return;
		}

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	};

	const handleFocusIn = () => {
		trapped = true;
	};

	const handleFocusOut = () => {
		trapped = false;
	};

	element.addEventListener('keydown', handleKeyDown);
	element.addEventListener('focusin', handleFocusIn);
	element.addEventListener('focusout', handleFocusOut);

	return () => {
		element.removeEventListener('keydown', handleKeyDown);
		element.addEventListener('focusin', handleFocusIn);
		element.addEventListener('focusout', handleFocusOut);
	};
};
